import { ActivityWizardData } from "../../../types";
import { ADDITIONAL_INFO_REQUIRED_FIELDS } from "../config/additionalInfoConfig";
import { ValidationResult } from "@components/WizardCst/types";

const isEmpty = (value: unknown): boolean => {
  if (value === null || value === undefined) return true;
  if (typeof value === "string") return value.trim().length === 0;
  if (Array.isArray(value)) return value.length === 0;
  return false;
};

export const validateAdditionalInfo = (
  data: ActivityWizardData,
): ValidationResult => {
  const errors: Record<string, string> = {};

  for (const field of ADDITIONAL_INFO_REQUIRED_FIELDS) {
    if (isEmpty(data[field as keyof ActivityWizardData])) {
      errors[field] = "required";
    }
  }

  data.useful_links.forEach((link, idx) => {
    if (isEmpty(link.url)) errors[`useful_links.${idx}.url`] = "required";
    if (isEmpty(link.url_label))
      errors[`useful_links.${idx}.url_label`] = "required";
  });

  if (!isEmpty(data.credits)) {
    const n = Number(data.credits);
    if (Number.isFinite(n) && (n < 0 || n > 1000)) {
      errors.credits = "credits-out-of-range";
    }
  }

  return { valid: Object.keys(errors).length === 0, errors };
};
